import type { OrderType } from "@/types";
import OrderListTable from "@univdiam/ui/customComponents/OrderList/OrderListTable"
import type { TableViewProps } from "@univdiam/ui/lib/SharedTypes";

import { useEffect, useState } from "react";

const TableView = ({ data, handleOrderOpen, globalFilter, setGlobalFilter, sorting, setSorting, columnVisibility, setColumnVisibility, onUpdateOrder, isAdmin, adminTags, fetchTags, page, setPage, pagination }: TableViewProps & { page?: number, setPage?: any, pagination?: any }) => {
  const [cards, setCards] = useState<OrderType[]>([]);
  useEffect(() => {
    if (data) {
      const transformed = data.map(order => ({
        ...order,
        column: order.status
      }))
      setCards(transformed)
    }
  }, [data])
  return (
    // <div className="min-h-screen w-full p-[24px]">
    <div className="min-h-screen w-full">
      <OrderListTable data={cards} handleOrderOpen={handleOrderOpen} onUpdateOrder={onUpdateOrder} isAdmin={isAdmin} adminTags={adminTags} fetchTags={fetchTags} page={page} setPage={setPage} pagination={pagination} {...{ globalFilter, setGlobalFilter, sorting, setSorting, columnVisibility, setColumnVisibility }} />
    </div>
  )
}

export default TableView